import { computed } from 'vue'


export default {
  __name: 'responsive-video',
  props: {
  url: {
    type: String,
    required: true,
    default: '',
  },
  width: {
    type: Number,
    required: true,
  },
  height: {
    type: Number,
    required: true,
  },
},
  setup(__props) {

const props = __props;



// CSP fix, also see: https://tinyurl.com/4n26nxdr
const src = computed(() => props.url.replace('watch?v=', 'embed/'))

return { __sfc: true,props, src }
}

}